import React from 'react';

import { ActionsRequisesDtoActionsRequisesEnum } from 'lib_api/lib/api/gen';

import BaseForm from 'components/BaseForm/BaseForm';
import FiltersSubForms from 'components/FiltersSubForms';
import { useApi } from 'hooks/ApiStoreContext';
import { CSSUtils } from 'utils/CSSUtils';

import {
  DashboardJusticeFilter,
  DashboardJusticeFilterForm,
} from '../../../types';

import FormFooter from './FormFooter/FormFooter';

interface FilterFormProps {
  filter: Partial<DashboardJusticeFilterForm>;
  setFilter: (value: Partial<DashboardJusticeFilterForm>) => void;
  actionsRequises?: ActionsRequisesDtoActionsRequisesEnum[];
}

function FilterFormJustice({
  filter,
  setFilter,
  actionsRequises,
}: Readonly<FilterFormProps>): React.ReactElement {
  const { ReferentielControllerApi: refController } = useApi();

  const initialsFilter = { ...filter };

  const subForms = FiltersSubForms(refController, actionsRequises);

  return (
    <BaseForm
      initialValues={initialsFilter}
      onChange={(changed, all: Partial<DashboardJusticeFilter>) => {
        return {
          ...all,
        };
      }}
      subForms={[
        {
          title: 'Général',
          inputs: [
            subForms.statut,
            subForms.fourriere,
            subForms.actionsRequises,
          ],
        },
        {
          title: 'Mise en fourrière',
          inputs: [
            subForms.natureMiseEnFourriere,
            subForms.dateRangeMiseEnFourriere,
          ],
        },
      ]}
      onSubmit={() => Promise.resolve()}
      renderButtonAction={() => <FormFooter setFilter={setFilter} />}
      wrapperCol={{ span: CSSUtils.LlargeWrapperCol }}
    />
  );
}

export default FilterFormJustice;
